module.exports = __webpack_public_path__ + "assets/images/slope-working/mobile.svg?v=61191abb";